import angular from 'angular';
import { AddressModule } from '@updater-components/address';
import { MoveFormComponent } from './move-form.component';

export const MoveFormModule = angular
  .module('app.account.moves.move-form', [AddressModule.name])
  .component('updMoveForm', MoveFormComponent);
